import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { BaseRefiService } from 'src/oldApp/services/base-refi.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-modal-upload-base-refi',
  templateUrl: './modal-upload-base-refi.component.html',
  styleUrls: ['./modal-upload-base-refi.component.css']
})
export class ModalUploadBaseRefiComponent implements OnInit {
  @Input() title:string=null;
  @Input() mode:string=null;
  @Input() year:string=null;
  @Input() month:string=null;

  // STATE
  public valid:boolean=false;
  public viewStatus:number=null;
  public details:string=null;
  public userId:number=null;
  public confirmTitle:string='<i class="icon-info-circled"></i>&nbsp;&nbsp;Ha seleccionado el siguiente archivo. Está seguro de cargar?';

  // FILES
  public selectedFiles:FileList;
  public currentFile:File=null;
  public progress:number=0;
  public fileInfos: Observable<any>;

  constructor(
    private baseRefiService:BaseRefiService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }

  ngOnInit() {
    this.viewStatus=1;
    this.userId=Number(localStorage.getItem('com_token'));
    //this.fileInfos = this.baseRefiService.getListBaseRefi();
  }

  // EVENTS
  selectFile(event:any) {
    this.selectedFiles = event.target.files;
  }
  isValid=()=> {
    this.valid=true;
    let errors=[];
    console.log(">> this.selectedFiles=", this.selectedFiles);
    if(this.fileError()) errors.push('&bull; Seleccione un archivo .xls o .xlsx!');
    if(errors.length>0) {
      this.valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return this.valid;
  }
  upload=()=> {
    if(this.isValid()){
      this.viewStatus=0;
      this.progress = 0;
      this.currentFile = this.selectedFiles.item(0);
      this.baseRefiService.upload(this.currentFile, this.userId, this.year, this.month).subscribe(
        event => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progress = Math.round(100 * event.loaded / event.total);
          } else if (event instanceof HttpResponse) {
            //this.fileInfos = this.baseRefiService.getListBaseRefi();
            this.modalService.dismissAll('success');
            this.toastr.success('El archivo se ha cargado correctamente!');
          }
        },
        err => {
          this.progress = 0;
          this.currentFile = undefined;
          this.modalService.dismissAll('failure');
          this.toastr.error('Ocurrió un error al intentar cargar el archivo...');
        });
        this.selectedFiles = undefined;
    }
  }
  close=()=> {
    this.modalService.dismissAll("cancel");
  }

  // HELPERS
  fileError=()=> !(this.selectedFiles != undefined && this.selectedFiles.length > 0 && (this.selectedFiles[0].name.split(".")[1] === "xls" || this.selectedFiles[0].name.split(".")[1] === "xlsx"));

}
